module.exports = __webpack_public_path__ + "imgs/MPP.28f238f85069c17fb06c208d25543980.png";